export const documentation = {
  junior: [
    { name: 'Product Owner Role Guide', url: '/docs/product-owner-guide', type: 'role-guide' },
    { name: 'Backlog Management Best Practices', url: '/docs/backlog-management', type: 'process' },
    { name: 'Sprint Planning Guidelines', url: '/docs/sprint-planning-po', type: 'agile' },
    { name: 'User Story Acceptance Criteria', url: '/docs/acceptance-criteria', type: 'requirements' },
    { name: 'Stakeholder Communication Framework', url: '/docs/stakeholder-communication-po', type: 'communication' }
  ],
  mid: [
    { name: 'Advanced Backlog Techniques', url: '/docs/advanced-backlog', type: 'process' },
    { name: 'Product Roadmap for Product Owners', url: '/docs/roadmap-product-owner', type: 'planning' },
    { name: 'Stakeholder Management Strategy', url: '/docs/stakeholder-management', type: 'stakeholder' },
    { name: 'Product Metrics for Product Owners', url: '/docs/product-metrics-po', type: 'metrics' },
    { name: 'Release Planning Framework', url: '/docs/release-planning', type: 'release' }
  ],
  senior: [
    { name: 'Product Owner Leadership', url: '/docs/po-leadership', type: 'leadership' },
    { name: 'Scaling Product Ownership', url: '/docs/scaling-po', type: 'scaling' },
    { name: 'Product Vision and Strategy for POs', url: '/docs/product-vision-po', type: 'vision' },
    { name: 'Cross-functional Team Leadership', url: '/docs/cross-functional-leadership', type: 'leadership' },
    { name: 'Innovation and Experimentation Framework', url: '/docs/innovation-framework', type: 'innovation' }
  ]
};
